import { useEffect, useRef } from "react";

import { DateTime } from "luxon";

import { Timeline } from "vis-timeline/standalone";

import { useAppSelector } from "app/hooks";
import { playbackSelectors } from "./store/selectors.playback";

export interface PlaybackTimelineMarkerProps {
    timelineInstance: Timeline;
}

export function PlaybackTimelineMarker(props: PlaybackTimelineMarkerProps) {
    // marker on timeline
    const currentTimeStamp = useAppSelector(
        playbackSelectors.selectCurrentPlaybackTimeStamp,
    );
    const timelineMarkerId = useRef<string>(undefined);

    useEffect(() => {
        if (!currentTimeStamp || currentTimeStamp < 0) return;

        if (!timelineMarkerId.current) {
            timelineMarkerId.current = `timeline-marker_${DateTime.now().toUnixInteger()}`;
            props.timelineInstance.addCustomTime(
                currentTimeStamp,
                timelineMarkerId.current,
            );
        } else {
            props.timelineInstance.setCustomTime(
                currentTimeStamp,
                timelineMarkerId.current,
            );
        }
    }, [currentTimeStamp, props.timelineInstance]);

    // in the future create a React based timeline
    return <></>;
}
